<div class="header flex justify-content-end gap-2">
  <!-- <div class="flex vertical-align-center"> -->
  <div class="totalprice">
    Precio:
    <span
      >{{ (product!.price + (product!.extraPrice || 0)).toFixed(2) }} €</span
    >
  </div>
  <!-- </div> -->
  <p-button label="Cancelar" severity="secondary" (onClick)="closeDialog()" />

  <p-button label="Añadir al carrito" (onClick)="addToCart()" />
  <!-- [disabled]="productIngredientForm.invalid" -->
</div>
<p-divider></p-divider>

<div class="body flex flex-column">
  <form>
    <!-- [formGroup]="productIngredientForm" -->
    <div class="flex grid m-0 align-items-center">
      <div class="checkbox col-12">
        <!-- <app-input-switch-molecule
          [form]="productTypeForm"
          [name]="'estado'"
          class="flex align-items-center justify-content-start flex-wrap w-full"
          label="Activo"
          classLabel="text-lg mb-1 mr-3"
        /> -->

        <!-- (click)=" toggleState(productType.estado) " -->
      </div>
      <!--
      <div class="checkbox col-6" [formGroup]="productTypeForm">
        <p-checkbox
          inputId="is_active"
          formControlName="is_active"
          ngDefaultControl
          trueValue="1"
          falseValue="0"
          [binary]="true"
          styleClass="mr-2">
        </p-checkbox>
        <label for="is_active">Activo</label>
      </div> -->
    </div>

    <div *ngFor="let ingredient of items" class="ingredient-item">
      <div class="image">
        <img src="{{ ingredient.image_url }}" alt="{{ ingredient.name }}" />
      </div>
      <div class="data">
        <div>
          <b>{{ ingredient.name }}</b>
        </div>
        <div>Extra {{ ingredient.price.toFixed(2) || 0 }} €</div>
      </div>

      <div class="actions">
        <app-quantity-counter
          [initialQuantity]="ingredient.initialQuantity || 0"
          [min]="0"
          [max]="2"
          (newQuantity)="
            calculateExtraAmount(ingredient, $event);
            calculatePrice();
            updateFinalIngredients(ingredient.productIngredientId, $event)
          "
        ></app-quantity-counter>

        <div>{{ ingredient.totalPrice!.toFixed(2) }} €</div>
      </div>
    </div>
  </form>
</div>
